export const MasterMenuTestIds = {
  PROFILE_LINK: 'master-menu.profile-link',
  LOGIN_LINK: 'master-menu.login-link',
  REGISTER_LINK: 'master-menu.register-link',
  MENU_BUTTON: 'master-menu.menu-button',
};
